module.exports = __webpack_public_path__ + "img/market.png?25a50348e3a77026aa193572b68102cb";